import React, { FunctionComponent, HTMLAttributes } from "react";
import styles from "./styles.module.scss";

type ContainerProps = {
    children: React.ReactNode;
    className?: string;
    disablePadding?: boolean;
} & HTMLAttributes<HTMLElement>;

const Container: FunctionComponent<ContainerProps> = ({ children, disablePadding = false, className = ``, ...rest }) => {
    return (
        <div className={`${styles.Container} ${disablePadding ? "" : styles.WithPadding} ${className}`} {...rest}>
            {children}
        </div>
    );
};

export default Container;
